import { apiInstance } from "./ApiInstance";

export const reportsDropdown = async (payload) => {
  let { data = {} } = await apiInstance.get("/api/mis/sub-category", payload);
  return data;
};

export const downloadReport = async (url) => {
  let { data = {} } = await apiInstance.get(url, { responseType: "blob" });
  return data;
};
